// extracted by mini-css-extract-plugin
export var animatemarquee = "smallcon-module--animatemarquee--64a9e";
export var animatemarquee2 = "smallcon-module--animatemarquee2--0b439";
export var logos = "smallcon-module--logos--ee6a7";
export var logosSlide = "smallcon-module--logosSlide--fcbe1";
export var marquee = "smallcon-module--marquee--507da";
export var marquee2 = "smallcon-module--marquee2--186c1";
export var slide = "smallcon-module--slide--39253";
export var smallconBg = "smallcon-module--smallconBg--65d69";